import React from 'react'
import BillPayDetail from 'src/app/BillPayDetail/BillPayDetail'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import BillPayAllAppRoute from 'src/navigation/appRoutes/billPayAll.appRoute'
import BillPayNeedsApprovalAppRoute from 'src/navigation/appRoutes/billPayNeedsApproval.appRoute'
import { billPayDetailRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const BillPayDetailAppRoute: AppRoute = {
  id: AppLocation.BillPayDetail,
  routeProps: billPayDetailRouteProps,
  component: <BillPayDetail />,
  subRoutes: [],
  exceptions: [BillPayAllAppRoute, BillPayNeedsApprovalAppRoute],
  meta: { contentType: SidenavContentType.Main },
}

export default BillPayDetailAppRoute
